"use client";

import { useEffect } from "react";
import sentryErrorService from "@/services/sentryErrorService";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    sentryErrorService.notify(error, {
      tags: {
        section: "app-router",
        function: "global-error-boundary",
      },
      extra: {
        digest: error.digest,
      },
    });
  }, [error]);

  return (
    <html lang="en">
      <body>
        <div className="flex min-h-screen flex-col items-center justify-center p-4">
          <div className="max-w-md text-center">
            <h1 className="mb-4 text-2xl font-bold">Something went wrong</h1>
            <p className="mb-6 text-gray-600">
              We encountered an unexpected error. Please try again.
            </p>
            {error.digest && (
              <p className="mb-4 text-sm text-gray-500">
                Error ID: {error.digest}
              </p>
            )}
            <button
              onClick={reset}
              className="rounded-lg bg-primary px-6 py-3 text-white"
            >
              Try Again
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
